export default {
	url: 'api/',
};
